<!--
 * @Description:
 * @Author: git config user.name
 * @Date: 2024-07-10 09:16:33
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-04-10 10:16:03
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\platform-services\anzhaocai.vue
-->
<template>
	<div class="h100 meeting-apply">
		<filter-layout @search="searchResult" @reset="resetSerach" hasHeader>
			<template #header>
				<el-tabs v-model="activeTab" @tab-click="tabChange(activeTab)">
					<el-tab-pane name="company" label="平台会员服务"> </el-tab-pane>
					<el-tab-pane name="user" label="移动认证管理"> </el-tab-pane>
					<el-tab-pane name="skill" label="平台技术服务费（包年）"> </el-tab-pane>
				</el-tabs>
			</template>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" label-width="80px" :model="searchForm">
					<el-form-item label="开通单位">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.tenantName" size="small"> </el-input>
					</el-form-item>
					<el-form-item label="税号">
						<el-input :placeholder="'请输入'" clearable v-model="searchForm.creditCode" size="small"> </el-input>
					</el-form-item>
					<el-form-item label="开通时间">
						<el-date-picker
							v-model="searchForm.times"
							type="daterange"
							range-separator="-"
							align="center"
							value-format="yyyy-MM-dd"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
						>
						</el-date-picker>
					</el-form-item>
					<el-form-item label-width="0">
						<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentDay')">今日</el-button>
						<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentMonth')">本月</el-button>
						<el-button class="btn-blue" type="primary" size="mini" @click="changeDateRange('currentYear')">本年</el-button>
					</el-form-item>
					<el-form-item label="生效状态">
						<el-select v-model="searchForm.invoiceStatus" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<div class="content-header">
					<div class="title-style">
						<span v-if="isHit == 0" class="color-red">当前服务未上架</span>
						<span v-if="isHit == 1" class="color-success">当前服务已上架，生效时间：{{ effectDate }}</span>
					</div>
					<div class="mt10 mb10 fr">
						<el-button type="primary" class="btn-blue" size="small" @click="changeBtn('add', '')">
							包年配置
						</el-button>
						<el-button type="primary" class="btn-blue" size="small" @click="doExport">
							导出
						</el-button>
					</div>
				</div>
				<div class="w-table-layout w-table-page">
					<div class="w-table-content bd-table">
						<el-table ref="xTable" highlight-current-row :data="filterData" height="100%" border>
							<el-table-column type="index" label="序号" align="center" width="60"></el-table-column>

							<el-table-column prop="payType" label="服务类型" header-align="left" min-width="150" show-overflow-tooltip>
								<template #default="{ row }">
									<span v-if="row.payType == 0">平台技术服务费（包年）</span>
								</template>
							</el-table-column>
							<el-table-column
								prop="tenantName"
								label="开通单位"
								header-align="left"
								min-width="200"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="creditCode"
								label="税号"
								header-align="left"
								min-width="150"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column prop="createUser" label="开通人" align="left" width="140" show-overflow-tooltip></el-table-column>
							<el-table-column prop="money" label="支付金额（元）" align="right" width="120" show-overflow-tooltip></el-table-column>
							<el-table-column prop="openTime" label="开通时间" align="left" width="150" show-overflow-tooltip></el-table-column>
							<el-table-column prop="expirationDate" label="服务有效期" align="left" width="180" show-overflow-tooltip>
							</el-table-column>
							<el-table-column prop="status" label="生效状态" align="left" width="100" show-overflow-tooltip>
								<template #default="{ row }">
									<span v-if="row.status == 1">已生效</span>
									<span v-else-if="row.status == 2">未生效</span>
									<span v-else-if="row.status == 3">已失效</span>
								</template>
							</el-table-column>
							<el-table-column align="left" width="180" label="操作">
								<template #default="{ row }">
									<el-button type="primary" size="small" round plain class="table-btn" @click="changeBtn('detail', row)">
										查看
									</el-button>
									<el-button
										type="primary"
										size="small"
										v-if="row.allowClose == 1"
										round
										plain
										class="table-btn"
										@click="changeBtn('close', row)"
									>
										关闭包年服务
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="currentPage"
							:page-sizes="pageList"
							:page-size="pageSize"
							:total="total"
							layout="total, sizes, prev, pager, next, jumper"
						>
						</el-pagination>
					</div>
				</div>
			</template>
		</filter-layout>
		<addDialog v-if="isAdd" ref="addDalog" @change="getData"></addDialog>
		<detailDialog ref="detailDialog"></detailDialog>

		<!-- 关闭包年服务 -->
		<close-dialog v-if="closeShowDialog" ref="close_dialog" @update="getData"></close-dialog>
	</div>
</template>

<script>
import { selectServiceFeePage } from 'api/modules/templateConfiguration'
import { exportPlus } from 'utils/tools'
import { mapState } from 'vuex'

import addDialog from './components/addDialog.vue'
import CloseDialog from './components/close-dialog.vue'
import detailDialog from './components/detailDialog.vue'

export default {
	name: '',
	components: { addDialog, detailDialog, CloseDialog },
	filters: {
		timeFilter(val) {
			if (val) {
				return val.split(' ')[0]
			}
		}
	},
	data() {
		return {
			options: [
				{
					value: 1,
					label: '生效'
				},
				{
					value: 2,
					label: '待生效'
				},
				{
					value: 3,
					label: '已失效'
				}
			],
			searchForm: {},
			filterData: [],
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			loading: false,
			isAdd: false,
			isHit: null, // 是否上下架
			effectDate: '', // 生效时间
			closeShowDialog: false, // 关闭包年服务
			activeTab: 'skill'
		}
	},
	created() {
		this.getData()
	},
	methods: {
		// tab切换
		tabChange(val) {
			if (val != 'skill') {
				this.$emit('tabChange', val)
			}
		},
		//查询
		searchResult() {
			this.currentPage = 1
			this.pageSize = 10
			this.getData()
		},
		//重置
		resetSerach() {
			this.searchForm = {}
			this.currentPage = 1
			this.pageSize = 10
			this.getData()
		},
		//列表
		getData() {
			let params = {} //Object.assign({}, this.searchForm);
			this.loading = true
			// 分页参数
			params.current = this.currentPage
			params.size = this.pageSize
			params.invoiceStatus = this.searchForm.invoiceStatus ? this.searchForm.invoiceStatus : 0
			params.tenantName = this.searchForm.tenantName ? this.searchForm.tenantName : ''
			params.creditCode = this.searchForm.creditCode ? this.searchForm.creditCode : ''
			params.startOfOpenTime = this.searchForm.times ? this.searchForm.times[0] : ''
			params.endOfOpenTime = this.searchForm.times ? this.searchForm.times[1] : ''
			selectServiceFeePage(params)
				.then((res) => {
					this.loading = false
					const data = res.data.serviceFeePage
					this.filterData = data.records
					this.currentPage = parseInt(data.current)
					this.total = parseInt(data.total)
					this.pageSize = parseInt(data.size)
					// 是否上下架
					this.isHit = res.data.isHit || 0
					// 生效时间
					this.effectDate = res.data.effectDate
				})
				.catch((err) => {
					this.isHit = 0
					this.loading = false
				})
		},
		//切换当前页码
		handleCurrentChange(val) {
			this.currentPage = val
			this.getData()
		},
		// 切换显示条数
		handleSizeChange(val) {
			this.pageSize = val
			this.getData()
		},
		//按钮操作
		changeBtn(type, row) {
			switch (type) {
				case 'add':
					this.isAdd = true
					setTimeout(() => {
						this.$refs.addDalog.visible = true
						this.$refs.addDalog.initData()
					}, 200)

					break
				case 'detail':
					this.$refs.detailDialog.visible = true
					this.$refs.detailDialog.getDetail(row.id)
					break
				case 'close':
					this.closeShowDialog = true
					setTimeout(() => {
						// this.$refs.addDalog.visible = true;
						this.$refs.close_dialog.initDialog(row.id)
					}, 200)
					break
			}
		},
		//导出
		doExport() {
			let params = {
				invoiceStatus: this.searchForm.invoiceStatus ? this.searchForm.invoiceStatus : 0,
				tenantName: this.searchForm.tenantName ? this.searchForm.tenantName : '',
				creditCode: this.searchForm.creditCode ? this.searchForm.creditCode : '',
				startOfOpenTime: this.searchForm.times ? this.searchForm.times[0] : '',
				endOfOpenTime: this.searchForm.times ? this.searchForm.times[1] : '',
				columns: [
					{
						field: 'index',
						title: '序号'
					},
					{
						field: 'payType',
						title: '服务类型'
					},
					{
						field: 'tenantName',
						title: '开通单位'
					},
					{
						field: 'creditCode',
						title: '税号'
					},
					{
						field: 'createUser',
						title: '开通人'
					},
					{
						field: 'money',
						title: '支付金额（元）'
					},
					{
						field: 'openTime',
						title: '开通时间'
					},
					{
						field: 'expirationDate',
						title: '服务有效期'
					},
					{
						field: 'status',
						title: '生效状态'
					}
				]
			}

			let path = '/userTenantCenter/expertServiceFee'
			//let path = 'http://172.16.0.50:8082'+ '/userTenantCenter/expertServiceFee'
			exportPlus(path, params)
		},

		// 快捷按钮选项 改变日期
		changeDateRange(type) {
			// 本日
			let dayStart = this.$utils.getWhatDay(new Date(), 0, 'first')
			let dayEnd = this.$utils.getWhatDay(new Date(), 0, 'last')
			// 本月
			let monthStart = this.$utils.getWhatMonth(new Date(), 0, 'first')
			let monthEnd = this.$utils.getWhatMonth(new Date(), 0, 'last')
			// 本年
			let yearStart = this.$utils.getWhatYear(new Date(), 0, 'first')
			let yearEnd = this.$utils.getWhatYear(new Date(), 0, 'last')
			switch (type) {
				case 'currentDay':
					this.searchForm.times = [this.$utils.toDateString(dayStart, 'yyyy-MM-dd'), this.$utils.toDateString(dayEnd, 'yyyy-MM-dd')]
					break
				case 'currentMonth':
					this.searchForm.times = [this.$utils.toDateString(monthStart, 'yyyy-MM-dd'), this.$utils.toDateString(monthEnd, 'yyyy-MM-dd')]
					break
				case 'currentYear':
					this.searchForm.times = [this.$utils.toDateString(yearStart, 'yyyy-MM-dd'), this.$utils.toDateString(yearEnd, 'yyyy-MM-dd')]
					break
			}
			this.searchResult()
		}
	},
	computed: {
		// 日期选择快捷选项
		pickerOptions() {
			let that = this
			// 本日
			let dayStart = this.$utils.getWhatDay(new Date(), 0, 'first')
			let dayEnd = this.$utils.getWhatDay(new Date(), 0, 'last')
			// 本月
			let monthStart = this.$utils.getWhatMonth(new Date(), 0, 'first')
			let monthEnd = this.$utils.getWhatMonth(new Date(), 0, 'last')
			// 本年
			let yearStart = this.$utils.getWhatYear(new Date(), 0, 'first')
			let yearEnd = this.$utils.getWhatYear(new Date(), 0, 'last')
			return {
				shortcuts: [
					{
						text: '今日',
						onClick(picker) {
							picker.$emit('pick', [dayStart, dayEnd])
							setTimeout(() => {
								that.searchResult()
							}, 200)
						}
					},
					{
						text: '本月',
						onClick(picker) {
							picker.$emit('pick', [monthStart, monthEnd])
							setTimeout(() => {
								that.searchResult()
							}, 200)
						}
					},
					{
						text: '本年',
						onClick(picker) {
							picker.$emit('pick', [yearStart, yearEnd])
							setTimeout(() => {
								that.searchResult()
							}, 200)
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.searchResult()
							}, 200)
						}
					},
					{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							picker.$emit('pick', [start, end])
							setTimeout(() => {
								that.searchResult()
							}, 200)
						}
					}
				]
			}
		}
	}
}
</script>

<style lang="less" scoped>
.meeting-apply {
	.filter-box {
		padding: 8px;
	}

	/deep/ .search-form {
		.el-form-item {
			margin-bottom: 5px;
		}
	}
	.content-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;
		.title {
			padding-left: 10px;
			border-left: 4px solid #2671cc;
			font-size: 14px;
			color: #202020;
		}
		.blue {
			font-size: 18px;
			color: #2671cc;
		}
	}
	.pd5 {
		padding: 0 5px;
	}
	.mb10 {
		margin-bottom: 10px;
	}

	.blue {
		color: #2671cc;
		cursor: pointer;
	}
}

.header-title {
	padding: 10px 0;
	overflow: hidden;
	padding-left: 10px;
}

.operation-layout .filter-box {
	padding-top: 5px;
	border-top: 1px solid #2671cc;
	border-bottom: none;
}

.title-style {
	font-size: 14px;
}
</style>
